import * as guiEditor from "gui-editor/legacy/legacy";
export { guiEditor };
export default guiEditor;
